import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRecurringPayAdjustmentTable extends Layout {
    buttonAddRecurringPayAdjustment: Button;
    sourceDrsRecurDeduct: DataSource;
    tableRecurringPayAdjustments: Table;
}
